export default {
    email: 'Email',
    phone: 'Phone',
    sms: 'SMS',
    messenger: 'Messenger',
    video: 'Video',

    asAction: {
        email: '{type} email',
        phone: '{type} call',
        sms: '{type} SMS',
        messenger: '{type} Facebook message',
        video: '{type} video call',
    },

    asOutgoingAction: {
        email: 'Outgoing email',
        phone: 'Outgoing call',
        sms: 'Outgoing SMS',
        messenger: 'Outgoing Facebook message',
        video: 'Outgoing video call',
    },
};
